import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'jhi-app-confirmation-dialog',
  template: `
    <div class="modal-header">
      <h4 class="modal-title">{{ title }}</h4>
    </div>
    <div [ngClass]="{'errorMessage': isError, 'modal-body': title}" >
      {{ message }}
    </div>
    <div class="modal-footer" [hidden]="hideButtons">
      <button type="button" *ngIf="btnCancelText" class="btn btn-option" (click)="decline()">{{ btnCancelText }}</button>
      <button type="button" *ngIf="btnOkText" class="btn btn-enable" (click)="accept()">{{ btnOkText }}</button>
    </div>
  `,
  styles: [`
      .errorMessage {
        color : red
      }
    `]
})
export default class ConfirmationDialogComponent implements OnInit {
  @Input() title: string;

  @Input() message: string;

  @Input() btnOkText: string;

  @Input() btnCancelText: string;

  @Input() hideButtons: boolean;

  @Input() timeoutOnShow: boolean;

  @Input() isError: boolean;

  constructor(private activeModal: NgbActiveModal) {}

  ngOnInit() {
    if (this.timeoutOnShow) {
      setTimeout(() => {
        this.activeModal.close(true);
      }, 3000);
    }
  }

  public decline() {
    this.activeModal.close(false);
  }

  public accept() {
    this.activeModal.close(true);
  }

  public dismiss() {
    this.activeModal.dismiss();
  }
}
